export { default } from './OutcomeTypeButton';
